import Flickity from './wwdevFlickity';
import CustomFlickity from "./CustomFlickity";

class FlickityCarousel {
	constructor(config) {
		this.config = Object.assign({
			scope: '.flickity-carousel',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each(function (it, el) {
			let settings = this.defaultSettings();

			Object.keys($(el).data()).forEach(function (key) {
				Object.assign(settings, {[key]: $(el).data(key)});
			});

			new Flickity(el, settings);
		}.bind(this));
        new CustomFlickity;
	}

	// Je kunt hier de standaard waardes aanpassen.
	defaultSettings() {
		return {
			cellAlign: 'left',
			contain: true,
			groupCells: true,
			arrowShape: 'M 41.962891 15.53125 L 0.0859375 49.978516 L 41.960938 84.466797 L 45.552734 80.105469 L 12.431641 52.828125 L 99.908203 52.828125 L 99.908203 47.177734 L 12.386719 47.177734 L 45.552734 19.894531 L 41.962891 15.53125 z '
		}
	}
}

export default FlickityCarousel;
